import React from 'react';
import './style.css';

export enum Type {
    Warning,
    Error,
}

interface Props {
    children: React.ReactNode;
    type: Type;
}

const warningIcon = (
    <svg className="shrink-0 -mt-1" width="30px" height="30px" viewBox="0 0 30 30">
        <g transform="translate(8.000000, 8.000000)">
            <circle fill="#FFC810" cx="7" cy="7" r="7" />
            <path
                d="M6.41946966,8.18524944 L6.16548764,4.48436854 L6.10501573,2.87581573 L7.89498427,2.87581573 L7.83451236,4.48436854 L7.58053034,8.18524944 L6.41946966,8.18524944 Z M7,11.1241843 C6.69360746,11.1241843 6.43761226,11.0173516 6.23200674,10.8036831 C6.02640122,10.5900147 5.9236,10.3259566 5.9236,10.0115011 C5.9236,9.68898266 6.02640122,9.4208932 6.23200674,9.20722472 C6.43761226,8.99355624 6.69360746,8.8867236 7,8.8867236 C7.30639254,8.8867236 7.56238774,8.99355624 7.76799326,9.20722472 C7.97359878,9.4208932 8.0764,9.68898266 8.0764,10.0115011 C8.0764,10.3259566 7.97359878,10.5900147 7.76799326,10.8036831 C7.56238774,11.0173516 7.30639254,11.1241843 7,11.1241843 Z"
                fill="#595562"
                fillRule="nonzero"
            />
        </g>
    </svg>
);

const errorIcon = (
    <svg className="shrink-0 -mt-1" width="30px" height="30px" viewBox="0 0 30 30">
        <g transform="translate(8.000000, 8.000000)">
            <circle fill="#EF5D37" cx="7" cy="7" r="7" />
            <path
                d="M6.41946966,8.18524944 L6.16548764,4.48436854 L6.10501573,2.87581573 L7.89498427,2.87581573 L7.83451236,4.48436854 L7.58053034,8.18524944 L6.41946966,8.18524944 Z M7,11.1241843 C6.69360746,11.1241843 6.43761226,11.0173516 6.23200674,10.8036831 C6.02640122,10.5900147 5.9236,10.3259566 5.9236,10.0115011 C5.9236,9.68898266 6.02640122,9.4208932 6.23200674,9.20722472 C6.43761226,8.99355624 6.69360746,8.8867236 7,8.8867236 C7.30639254,8.8867236 7.56238774,8.99355624 7.76799326,9.20722472 C7.97359878,9.4208932 8.0764,9.68898266 8.0764,10.0115011 C8.0764,10.3259566 7.97359878,10.5900147 7.76799326,10.8036831 C7.56238774,11.0173516 7.30639254,11.1241843 7,11.1241843 Z"
                fill="#FFFFFF"
                fillRule="nonzero"
            />
        </g>
    </svg>
);

export default function Note({ children, type }: Props) {
    return (
        <div className="e_docs_onboarding__note text-xs pb-5">
            <label className="flex">
                {type === Type.Warning && warningIcon}
                {type === Type.Error && errorIcon}
                {children}
            </label>
        </div>
    );
}
